"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationHttpService = void 0;
var CommonService_decorator_1 = require("../../decorators/CommonService.decorator");
var SeismicHelper_1 = require("../../helper/SeismicHelper");
var Http_service_1 = require("../http/Http.service");
var JsonApi_service_1 = require("./JsonApi.service");
var NotificationHttpService = /** @class */ (function () {
    function NotificationHttpService(jsonApiService, httpService, seismicHelper) {
        this.jsonApiService = jsonApiService;
        this.httpService = httpService;
        this.seismicHelper = seismicHelper;
    }
    NotificationHttpService.prototype.getAnnouncementsWithScopesV2 = function () {
        var url = this.seismicHelper.getRootURL() + "/JsonServiceApi/NotificationService.svc" + this.jsonApiService.getParamsWithSignature('AnnouncementsWithScopesV2');
        return this.httpService.post(url);
    };
    NotificationHttpService = __decorate([
        CommonService_decorator_1.CommonService('NotificationHttpService'),
        __metadata("design:paramtypes", [JsonApi_service_1.JsonApiService,
            Http_service_1.HttpService,
            SeismicHelper_1.SeismicHelper])
    ], NotificationHttpService);
    return NotificationHttpService;
}());
exports.NotificationHttpService = NotificationHttpService;
//# sourceMappingURL=NotificationHttp.service.js.map